import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Organisationseinheit')

export default {
  label: 'Person',
  route: 'person',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('ueberOrganisationseinheit', 'sitemap', 'organisationseinheit'),
    Filter.String('name'),
    Filter.String('kostenstelle'),
    {
      label: 'Organisationseinheit.list.filter.inPubfob',
      field: 'inPubfob',
      type: 'select',
      translatable: true,
      values: [
        {
          value: 'TRUE',
          label: 'Organisationseinheit.inPubfob.TRUE'
        },
        {
          value: 'FALSE',
          label: 'Organisationseinheit.inPubfob.FALSE'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/OrganisationseinheitFilter.js